import { x as de, g as Ke, j as b, i as M, B as L, h as G, l as q, m as Z, r as Je, p as Qe, q as Q, K as Ze, L as eo, w as Ce, s as ue, U as oo, n as he, v as to } from "./UnstyledButton-ujNMaBde.js";
import { useRef as z, useEffect as j, useMemo as we, forwardRef as A, useState as C, useContext as ro, createContext as no } from "react";
import { o as Pe, I as oe, c as lo, a as Te, m as so, p as ke, u as co } from "./Button-CMUmoC07.js";
import { c as Re, u as ao } from "./DirectionProvider-DtCDJ2BX.js";
import { u as io, a as K } from "./CloseButton-Bp_UJ8Gq.js";
function X(e) {
  const t = z(e);
  return j(() => {
    t.current = e;
  }), we(() => ((...o) => t.current?.(...o)), []);
}
function re(e, t) {
  const { delay: o, flushOnUnmount: s, leading: l } = typeof t == "number" ? { delay: t, flushOnUnmount: !1, leading: !1 } : t, n = X(e), r = z(0), c = we(() => {
    const a = Object.assign(
      (...d) => {
        window.clearTimeout(r.current);
        const i = a._isFirstCall;
        a._isFirstCall = !1;
        function u() {
          window.clearTimeout(r.current), r.current = 0, a._isFirstCall = !0;
        }
        if (l && i) {
          n(...d);
          const m = () => {
            u();
          }, v = () => {
            r.current !== 0 && (u(), n(...d));
          }, p = () => {
            u();
          };
          a.flush = v, a.cancel = p, r.current = window.setTimeout(m, o);
          return;
        }
        if (l && !i) {
          const m = () => {
            r.current !== 0 && (u(), n(...d));
          }, v = () => {
            u();
          };
          a.flush = m, a.cancel = v;
          const p = () => {
            u();
          };
          r.current = window.setTimeout(p, o);
          return;
        }
        const f = () => {
          r.current !== 0 && (u(), n(...d));
        }, h = () => {
          u();
        };
        a.flush = f, a.cancel = h, r.current = window.setTimeout(f, o);
      },
      {
        flush: () => {
        },
        cancel: () => {
        },
        _isFirstCall: !0
      }
    );
    return a;
  }, [n, o, l]);
  return j(
    () => () => {
      s ? c.flush() : c.cancel();
    },
    [c, s]
  ), c;
}
function be({ color: e, theme: t, autoContrast: o }) {
  return (typeof o == "boolean" ? o : t.autoContrast) && de({ color: e || t.primaryColor, theme: t }).isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
}
function $o(e, t) {
  return be({
    color: e.colors[e.primaryColor][Ke(e, t)],
    theme: e,
    autoContrast: null
  });
}
function Ae(e, t) {
  return typeof e == "boolean" ? e : t.autoContrast;
}
var fe = { root: "m_d57069b5", content: "m_b1336c6", viewport: "m_c0783ff9", viewportInner: "m_f8f631dd", scrollbar: "m_c44ba933", thumb: "m_d8b5e363", corner: "m_21657268" };
const [uo, E] = Re(
  "ScrollArea.Root component was not found in tree"
);
function B(e, t) {
  const o = X(t);
  io(() => {
    let s = 0;
    if (e) {
      const l = new ResizeObserver(() => {
        cancelAnimationFrame(s), s = window.requestAnimationFrame(o);
      });
      return l.observe(e), () => {
        window.cancelAnimationFrame(s), l.unobserve(e);
      };
    }
  }, [e, o]);
}
const ho = A((e, t) => {
  const { style: o, ...s } = e, l = E(), [n, r] = C(0), [c, a] = C(0), d = !!(n && c);
  return B(l.scrollbarX, () => {
    const i = l.scrollbarX?.offsetHeight || 0;
    l.onCornerHeightChange(i), a(i);
  }), B(l.scrollbarY, () => {
    const i = l.scrollbarY?.offsetWidth || 0;
    l.onCornerWidthChange(i), r(i);
  }), d ? /* @__PURE__ */ b.jsx("div", { ...s, ref: t, style: { ...o, width: n, height: c } }) : null;
}), bo = A((e, t) => {
  const o = E(), s = !!(o.scrollbarX && o.scrollbarY);
  return o.type !== "scroll" && s ? /* @__PURE__ */ b.jsx(ho, { ...e, ref: t }) : null;
}), fo = {
  scrollHideDelay: 1e3,
  type: "hover"
}, je = A((e, t) => {
  const { type: o, scrollHideDelay: s, scrollbars: l, getStyles: n, ...r } = M(
    "ScrollAreaRoot",
    fo,
    e
  ), [c, a] = C(null), [d, i] = C(null), [u, f] = C(null), [h, m] = C(null), [v, p] = C(null), [g, k] = C(0), [w, P] = C(0), [x, R] = C(!1), [y, S] = C(!1), T = K(t, (W) => a(W));
  return /* @__PURE__ */ b.jsx(
    uo,
    {
      value: {
        type: o,
        scrollHideDelay: s,
        scrollArea: c,
        viewport: d,
        onViewportChange: i,
        content: u,
        onContentChange: f,
        scrollbarX: h,
        onScrollbarXChange: m,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: R,
        scrollbarY: v,
        onScrollbarYChange: p,
        scrollbarYEnabled: y,
        onScrollbarYEnabledChange: S,
        onCornerWidthChange: k,
        onCornerHeightChange: P,
        getStyles: n
      },
      children: /* @__PURE__ */ b.jsx(
        L,
        {
          ...r,
          ref: T,
          __vars: {
            "--sa-corner-width": l !== "xy" ? "0px" : `${g}px`,
            "--sa-corner-height": l !== "xy" ? "0px" : `${w}px`
          }
        }
      )
    }
  );
});
je.displayName = "@mantine/core/ScrollAreaRoot";
function _e(e, t) {
  const o = e / t;
  return Number.isNaN(o) ? 0 : o;
}
function ne(e) {
  const t = _e(e.viewport, e.content), o = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, s = (e.scrollbar.size - o) * t;
  return Math.max(s, 18);
}
function ze(e, t) {
  return (o) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const s = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + s * (o - e[0]);
  };
}
function po(e, [t, o]) {
  return Math.min(o, Math.max(t, e));
}
function ye(e, t, o = "ltr") {
  const s = ne(t), l = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, n = t.scrollbar.size - l, r = t.content - t.viewport, c = n - s, a = o === "ltr" ? [0, r] : [r * -1, 0], d = po(e, a);
  return ze([0, r], [0, c])(d);
}
function mo(e, t, o, s = "ltr") {
  const l = ne(o), n = l / 2, r = t || n, c = l - r, a = o.scrollbar.paddingStart + r, d = o.scrollbar.size - o.scrollbar.paddingEnd - c, i = o.content - o.viewport, u = s === "ltr" ? [0, i] : [i * -1, 0];
  return ze([a, d], u)(e);
}
function He(e, t) {
  return e > 0 && e < t;
}
function te(e) {
  return e ? parseInt(e, 10) : 0;
}
function U(e, t, { checkForDefaultPrevented: o = !0 } = {}) {
  return (s) => {
    e?.(s), (o === !1 || !s.defaultPrevented) && t?.(s);
  };
}
const [vo, De] = Re(
  "ScrollAreaScrollbar was not found in tree"
), Ee = A((e, t) => {
  const {
    sizes: o,
    hasThumb: s,
    onThumbChange: l,
    onThumbPointerUp: n,
    onThumbPointerDown: r,
    onThumbPositionChange: c,
    onDragScroll: a,
    onWheelScroll: d,
    onResize: i,
    ...u
  } = e, f = E(), [h, m] = C(null), v = K(t, (S) => m(S)), p = z(null), g = z(""), { viewport: k } = f, w = o.content - o.viewport, P = X(d), x = X(c), R = re(i, 10), y = (S) => {
    if (p.current) {
      const T = S.clientX - p.current.left, W = S.clientY - p.current.top;
      a({ x: T, y: W });
    }
  };
  return j(() => {
    const S = (T) => {
      const W = T.target;
      h?.contains(W) && P(T, w);
    };
    return document.addEventListener("wheel", S, { passive: !1 }), () => document.removeEventListener("wheel", S, { passive: !1 });
  }, [k, h, w, P]), j(x, [o, x]), B(h, R), B(f.content, R), /* @__PURE__ */ b.jsx(
    vo,
    {
      value: {
        scrollbar: h,
        hasThumb: s,
        onThumbChange: X(l),
        onThumbPointerUp: X(n),
        onThumbPositionChange: x,
        onThumbPointerDown: X(r)
      },
      children: /* @__PURE__ */ b.jsx(
        "div",
        {
          ...u,
          ref: v,
          "data-mantine-scrollbar": !0,
          style: { position: "absolute", ...u.style },
          onPointerDown: U(e.onPointerDown, (S) => {
            S.preventDefault(), S.button === 0 && (S.target.setPointerCapture(S.pointerId), p.current = h.getBoundingClientRect(), g.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", y(S));
          }),
          onPointerMove: U(e.onPointerMove, y),
          onPointerUp: U(e.onPointerUp, (S) => {
            const T = S.target;
            T.hasPointerCapture(S.pointerId) && (S.preventDefault(), T.releasePointerCapture(S.pointerId));
          }),
          onLostPointerCapture: () => {
            document.body.style.webkitUserSelect = g.current, p.current = null;
          }
        }
      )
    }
  );
}), We = A(
  (e, t) => {
    const { sizes: o, onSizesChange: s, style: l, ...n } = e, r = E(), [c, a] = C(), d = z(null), i = K(t, d, r.onScrollbarXChange);
    return j(() => {
      d.current && a(getComputedStyle(d.current));
    }, [d]), /* @__PURE__ */ b.jsx(
      Ee,
      {
        "data-orientation": "horizontal",
        ...n,
        ref: i,
        sizes: o,
        style: {
          ...l,
          "--sa-thumb-width": `${ne(o)}px`
        },
        onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
        onDragScroll: (u) => e.onDragScroll(u.x),
        onWheelScroll: (u, f) => {
          if (r.viewport) {
            const h = r.viewport.scrollLeft + u.deltaX;
            e.onWheelScroll(h), He(h, f) && u.preventDefault();
          }
        },
        onResize: () => {
          d.current && r.viewport && c && s({
            content: r.viewport.scrollWidth,
            viewport: r.viewport.offsetWidth,
            scrollbar: {
              size: d.current.clientWidth,
              paddingStart: te(c.paddingLeft),
              paddingEnd: te(c.paddingRight)
            }
          });
        }
      }
    );
  }
);
We.displayName = "@mantine/core/ScrollAreaScrollbarX";
const Le = A(
  (e, t) => {
    const { sizes: o, onSizesChange: s, style: l, ...n } = e, r = E(), [c, a] = C(), d = z(null), i = K(t, d, r.onScrollbarYChange);
    return j(() => {
      d.current && a(window.getComputedStyle(d.current));
    }, []), /* @__PURE__ */ b.jsx(
      Ee,
      {
        ...n,
        "data-orientation": "vertical",
        ref: i,
        sizes: o,
        style: {
          "--sa-thumb-height": `${ne(o)}px`,
          ...l
        },
        onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
        onDragScroll: (u) => e.onDragScroll(u.y),
        onWheelScroll: (u, f) => {
          if (r.viewport) {
            const h = r.viewport.scrollTop + u.deltaY;
            e.onWheelScroll(h), He(h, f) && u.preventDefault();
          }
        },
        onResize: () => {
          d.current && r.viewport && c && s({
            content: r.viewport.scrollHeight,
            viewport: r.viewport.offsetHeight,
            scrollbar: {
              size: d.current.clientHeight,
              paddingStart: te(c.paddingTop),
              paddingEnd: te(c.paddingBottom)
            }
          });
        }
      }
    );
  }
);
Le.displayName = "@mantine/core/ScrollAreaScrollbarY";
const le = A((e, t) => {
  const { orientation: o = "vertical", ...s } = e, { dir: l } = ao(), n = E(), r = z(null), c = z(0), [a, d] = C({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), i = _e(a.viewport, a.content), u = {
    ...s,
    sizes: a,
    onSizesChange: d,
    hasThumb: i > 0 && i < 1,
    onThumbChange: (h) => {
      r.current = h;
    },
    onThumbPointerUp: () => {
      c.current = 0;
    },
    onThumbPointerDown: (h) => {
      c.current = h;
    }
  }, f = (h, m) => mo(h, c.current, a, m);
  return o === "horizontal" ? /* @__PURE__ */ b.jsx(
    We,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollLeft, m = ye(h, a, l);
          r.current.style.transform = `translate3d(${m}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = f(h, l));
      }
    }
  ) : o === "vertical" ? /* @__PURE__ */ b.jsx(
    Le,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollTop, m = ye(h, a);
          a.scrollbar.size === 0 ? r.current.style.setProperty("--thumb-opacity", "0") : r.current.style.setProperty("--thumb-opacity", "1"), r.current.style.transform = `translate3d(0, ${m}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = f(h));
      }
    }
  ) : null;
});
le.displayName = "@mantine/core/ScrollAreaScrollbarVisible";
const pe = A(
  (e, t) => {
    const o = E(), { forceMount: s, ...l } = e, [n, r] = C(!1), c = e.orientation === "horizontal", a = re(() => {
      if (o.viewport) {
        const d = o.viewport.offsetWidth < o.viewport.scrollWidth, i = o.viewport.offsetHeight < o.viewport.scrollHeight;
        r(c ? d : i);
      }
    }, 10);
    return B(o.viewport, a), B(o.content, a), s || n ? /* @__PURE__ */ b.jsx(
      le,
      {
        "data-state": n ? "visible" : "hidden",
        ...l,
        ref: t
      }
    ) : null;
  }
);
pe.displayName = "@mantine/core/ScrollAreaScrollbarAuto";
const Ne = A(
  (e, t) => {
    const { forceMount: o, ...s } = e, l = E(), [n, r] = C(!1);
    return j(() => {
      const { scrollArea: c } = l;
      let a = 0;
      if (c) {
        const d = () => {
          window.clearTimeout(a), r(!0);
        }, i = () => {
          a = window.setTimeout(() => r(!1), l.scrollHideDelay);
        };
        return c.addEventListener("pointerenter", d), c.addEventListener("pointerleave", i), () => {
          window.clearTimeout(a), c.removeEventListener("pointerenter", d), c.removeEventListener("pointerleave", i);
        };
      }
    }, [l.scrollArea, l.scrollHideDelay]), o || n ? /* @__PURE__ */ b.jsx(
      pe,
      {
        "data-state": n ? "visible" : "hidden",
        ...s,
        ref: t
      }
    ) : null;
  }
);
Ne.displayName = "@mantine/core/ScrollAreaScrollbarHover";
const xo = A(
  (e, t) => {
    const { forceMount: o, ...s } = e, l = E(), n = e.orientation === "horizontal", [r, c] = C("hidden"), a = re(() => c("idle"), 100);
    return j(() => {
      if (r === "idle") {
        const d = window.setTimeout(() => c("hidden"), l.scrollHideDelay);
        return () => window.clearTimeout(d);
      }
    }, [r, l.scrollHideDelay]), j(() => {
      const { viewport: d } = l, i = n ? "scrollLeft" : "scrollTop";
      if (d) {
        let u = d[i];
        const f = () => {
          const h = d[i];
          u !== h && (c("scrolling"), a()), u = h;
        };
        return d.addEventListener("scroll", f), () => d.removeEventListener("scroll", f);
      }
    }, [l.viewport, n, a]), o || r !== "hidden" ? /* @__PURE__ */ b.jsx(
      le,
      {
        "data-state": r === "hidden" ? "hidden" : "visible",
        ...s,
        ref: t,
        onPointerEnter: U(e.onPointerEnter, () => c("interacting")),
        onPointerLeave: U(e.onPointerLeave, () => c("idle"))
      }
    ) : null;
  }
), ae = A(
  (e, t) => {
    const { forceMount: o, ...s } = e, l = E(), { onScrollbarXEnabledChange: n, onScrollbarYEnabledChange: r } = l, c = e.orientation === "horizontal";
    return j(() => (c ? n(!0) : r(!0), () => {
      c ? n(!1) : r(!1);
    }), [c, n, r]), l.type === "hover" ? /* @__PURE__ */ b.jsx(Ne, { ...s, ref: t, forceMount: o }) : l.type === "scroll" ? /* @__PURE__ */ b.jsx(xo, { ...s, ref: t, forceMount: o }) : l.type === "auto" ? /* @__PURE__ */ b.jsx(pe, { ...s, ref: t, forceMount: o }) : l.type === "always" ? /* @__PURE__ */ b.jsx(le, { ...s, ref: t }) : null;
  }
);
ae.displayName = "@mantine/core/ScrollAreaScrollbar";
function So(e, t = () => {
}) {
  let o = { left: e.scrollLeft, top: e.scrollTop }, s = 0;
  return (function l() {
    const n = { left: e.scrollLeft, top: e.scrollTop }, r = o.left !== n.left, c = o.top !== n.top;
    (r || c) && t(), o = n, s = window.requestAnimationFrame(l);
  })(), () => window.cancelAnimationFrame(s);
}
const Ie = A((e, t) => {
  const { style: o, ...s } = e, l = E(), n = De(), { onThumbPositionChange: r } = n, c = K(t, (i) => n.onThumbChange(i)), a = z(void 0), d = re(() => {
    a.current && (a.current(), a.current = void 0);
  }, 100);
  return j(() => {
    const { viewport: i } = l;
    if (i) {
      const u = () => {
        if (d(), !a.current) {
          const f = So(i, r);
          a.current = f, r();
        }
      };
      return r(), i.addEventListener("scroll", u), () => i.removeEventListener("scroll", u);
    }
  }, [l.viewport, d, r]), /* @__PURE__ */ b.jsx(
    "div",
    {
      "data-state": n.hasThumb ? "visible" : "hidden",
      ...s,
      ref: c,
      style: {
        width: "var(--sa-thumb-width)",
        height: "var(--sa-thumb-height)",
        ...o
      },
      onPointerDownCapture: U(e.onPointerDownCapture, (i) => {
        const f = i.target.getBoundingClientRect(), h = i.clientX - f.left, m = i.clientY - f.top;
        n.onThumbPointerDown({ x: h, y: m });
      }),
      onPointerUp: U(e.onPointerUp, n.onThumbPointerUp)
    }
  );
});
Ie.displayName = "@mantine/core/ScrollAreaThumb";
const ie = A(
  (e, t) => {
    const { forceMount: o, ...s } = e, l = De();
    return o || l.hasThumb ? /* @__PURE__ */ b.jsx(Ie, { ref: t, ...s }) : null;
  }
);
ie.displayName = "@mantine/core/ScrollAreaThumb";
const Ve = A(
  ({ children: e, style: t, onWheel: o, ...s }, l) => {
    const n = E(), r = K(l, n.onViewportChange), c = (a) => {
      if (o?.(a), n.scrollbarXEnabled && n.viewport && a.shiftKey) {
        const { scrollTop: d, scrollHeight: i, clientHeight: u, scrollWidth: f, clientWidth: h } = n.viewport, m = d < 1, v = d >= i - u - 1;
        f > h && (m || v) && a.stopPropagation();
      }
    };
    return /* @__PURE__ */ b.jsx(
      L,
      {
        ...s,
        ref: r,
        onWheel: c,
        style: {
          overflowX: n.scrollbarXEnabled ? "scroll" : "hidden",
          overflowY: n.scrollbarYEnabled ? "scroll" : "hidden",
          ...t
        },
        children: /* @__PURE__ */ b.jsx("div", { ...n.getStyles("content"), ref: n.onContentChange, children: e })
      }
    );
  }
);
Ve.displayName = "@mantine/core/ScrollAreaViewport";
const $e = {
  scrollHideDelay: 1e3,
  type: "hover",
  scrollbars: "xy"
}, go = Z(
  (e, { scrollbarSize: t, overscrollBehavior: o, scrollbars: s }) => {
    let l = o;
    return o && s && (s === "x" ? l = `${o} auto` : s === "y" && (l = `auto ${o}`)), {
      root: {
        "--scrollarea-scrollbar-size": Je(t),
        "--scrollarea-over-scroll-behavior": l
      }
    };
  }
), se = G((e, t) => {
  const o = M("ScrollArea", $e, e), {
    classNames: s,
    className: l,
    style: n,
    styles: r,
    unstyled: c,
    scrollbarSize: a,
    vars: d,
    type: i,
    scrollHideDelay: u,
    viewportProps: f,
    viewportRef: h,
    onScrollPositionChange: m,
    children: v,
    offsetScrollbars: p,
    scrollbars: g,
    onBottomReached: k,
    onTopReached: w,
    overscrollBehavior: P,
    attributes: x,
    ...R
  } = o, [y, S] = C(!1), [T, W] = C(!1), [N, I] = C(!1), _ = q({
    name: "ScrollArea",
    props: o,
    classes: fe,
    className: l,
    style: n,
    classNames: s,
    styles: r,
    unstyled: c,
    attributes: x,
    vars: d,
    varsResolver: go
  }), H = z(null), V = Pe([h, H]);
  return j(() => {
    if (!H.current || p !== "present")
      return;
    const D = H.current, O = new ResizeObserver(() => {
      const { scrollHeight: $, clientHeight: Y, scrollWidth: J, clientWidth: ce } = D;
      W($ > Y), I(J > ce);
    });
    return O.observe(D), () => O.disconnect();
  }, [H, p]), /* @__PURE__ */ b.jsxs(
    je,
    {
      getStyles: _,
      type: i === "never" ? "always" : i,
      scrollHideDelay: u,
      ref: t,
      scrollbars: g,
      ..._("root"),
      ...R,
      children: [
        /* @__PURE__ */ b.jsx(
          Ve,
          {
            ...f,
            ..._("viewport", { style: f?.style }),
            ref: V,
            "data-offset-scrollbars": p === !0 ? "xy" : p || void 0,
            "data-scrollbars": g || void 0,
            "data-horizontal-hidden": p === "present" && !N ? "true" : void 0,
            "data-vertical-hidden": p === "present" && !T ? "true" : void 0,
            onScroll: (D) => {
              f?.onScroll?.(D), m?.({ x: D.currentTarget.scrollLeft, y: D.currentTarget.scrollTop });
              const { scrollTop: O, scrollHeight: $, clientHeight: Y } = D.currentTarget;
              O - ($ - Y) >= -0.8 && k?.(), O === 0 && w?.();
            },
            children: v
          }
        ),
        (g === "xy" || g === "x") && /* @__PURE__ */ b.jsx(
          ae,
          {
            ..._("scrollbar"),
            orientation: "horizontal",
            "data-hidden": i === "never" || p === "present" && !N ? !0 : void 0,
            forceMount: !0,
            onMouseEnter: () => S(!0),
            onMouseLeave: () => S(!1),
            children: /* @__PURE__ */ b.jsx(ie, { ..._("thumb") })
          }
        ),
        (g === "xy" || g === "y") && /* @__PURE__ */ b.jsx(
          ae,
          {
            ..._("scrollbar"),
            orientation: "vertical",
            "data-hidden": i === "never" || p === "present" && !T ? !0 : void 0,
            forceMount: !0,
            onMouseEnter: () => S(!0),
            onMouseLeave: () => S(!1),
            children: /* @__PURE__ */ b.jsx(ie, { ..._("thumb") })
          }
        ),
        /* @__PURE__ */ b.jsx(
          bo,
          {
            ..._("corner"),
            "data-hovered": y || void 0,
            "data-hidden": i === "never" || void 0
          }
        )
      ]
    }
  );
});
se.displayName = "@mantine/core/ScrollArea";
const me = G((e, t) => {
  const {
    children: o,
    classNames: s,
    styles: l,
    scrollbarSize: n,
    scrollHideDelay: r,
    type: c,
    dir: a,
    offsetScrollbars: d,
    overscrollBehavior: i,
    viewportRef: u,
    onScrollPositionChange: f,
    unstyled: h,
    variant: m,
    viewportProps: v,
    scrollbars: p,
    style: g,
    vars: k,
    onBottomReached: w,
    onTopReached: P,
    onOverflowChange: x,
    ...R
  } = M("ScrollAreaAutosize", $e, e), y = z(null), S = Pe([u, y]), [T, W] = C(!1), N = z(!1);
  return j(() => {
    if (!x)
      return;
    const I = y.current;
    if (!I)
      return;
    const _ = () => {
      const V = I.scrollHeight > I.clientHeight;
      V !== T && (N.current ? x?.(V) : (N.current = !0, V && x?.(!0)), W(V));
    };
    _();
    const H = new ResizeObserver(_);
    return H.observe(I), () => H.disconnect();
  }, [x, T]), /* @__PURE__ */ b.jsx(L, { ...R, ref: t, style: [{ display: "flex", overflow: "hidden" }, g], children: /* @__PURE__ */ b.jsx(
    L,
    {
      style: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "hidden",
        ...p === "y" && { minWidth: 0 },
        ...p === "x" && { minHeight: 0 },
        ...p === "xy" && { minWidth: 0, minHeight: 0 },
        ...p === !1 && { minWidth: 0, minHeight: 0 }
      },
      children: /* @__PURE__ */ b.jsx(
        se,
        {
          classNames: s,
          styles: l,
          scrollHideDelay: r,
          scrollbarSize: n,
          type: c,
          dir: a,
          offsetScrollbars: d,
          overscrollBehavior: i,
          viewportRef: S,
          onScrollPositionChange: f,
          unstyled: h,
          variant: m,
          viewportProps: v,
          vars: k,
          scrollbars: p,
          onBottomReached: w,
          onTopReached: P,
          "data-autosize": "true",
          children: o
        }
      )
    }
  ) });
});
se.classes = fe;
me.displayName = "@mantine/core/ScrollAreaAutosize";
me.classes = fe;
se.Autosize = me;
var Fe = { root: "m_b6d8b162" };
function yo(e) {
  if (e === "start")
    return "start";
  if (e === "end" || e)
    return "end";
}
const Co = {
  inherit: !1
}, wo = Z(
  // Will be removed in 9.0
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  (e, { variant: t, lineClamp: o, gradient: s, size: l, color: n }) => ({
    root: {
      "--text-fz": Ce(l),
      "--text-lh": eo(l),
      "--text-gradient": t === "gradient" ? Ze(s, e) : void 0,
      "--text-line-clamp": typeof o == "number" ? o.toString() : void 0,
      "--text-color": n ? Q(n, e) : void 0
    }
  })
), Me = Qe((e, t) => {
  const o = M("Text", Co, e), {
    lineClamp: s,
    truncate: l,
    inline: n,
    inherit: r,
    gradient: c,
    span: a,
    __staticSelector: d,
    vars: i,
    className: u,
    style: f,
    classNames: h,
    styles: m,
    unstyled: v,
    variant: p,
    mod: g,
    size: k,
    attributes: w,
    ...P
  } = o, x = q({
    name: ["Text", d],
    props: o,
    classes: Fe,
    className: u,
    style: f,
    classNames: h,
    styles: m,
    unstyled: v,
    attributes: w,
    vars: i,
    varsResolver: wo
  });
  return /* @__PURE__ */ b.jsx(
    L,
    {
      ...x("root", { focusable: !0 }),
      ref: t,
      component: a ? "span" : "p",
      variant: p,
      mod: [
        {
          "data-truncate": yo(l),
          "data-line-clamp": typeof s == "number",
          "data-inline": n,
          "data-inherit": r
        },
        g
      ],
      size: k,
      ...P
    }
  );
});
Me.classes = Fe;
Me.displayName = "@mantine/core/Text";
var Oe = { root: "m_5f75b09e", body: "m_5f6e695e", labelWrapper: "m_d3ea56bb", label: "m_8ee546b8", description: "m_328f68c0", error: "m_8e8a99cc" };
const Po = Oe, Xe = A(
  ({
    __staticSelector: e,
    __stylesApiProps: t,
    className: o,
    classNames: s,
    styles: l,
    unstyled: n,
    children: r,
    label: c,
    description: a,
    id: d,
    disabled: i,
    error: u,
    size: f,
    labelPosition: h = "left",
    bodyElement: m = "div",
    labelElement: v = "label",
    variant: p,
    style: g,
    vars: k,
    mod: w,
    attributes: P,
    ...x
  }, R) => {
    const y = q({
      name: e,
      props: t,
      className: o,
      style: g,
      classes: Oe,
      classNames: s,
      styles: l,
      unstyled: n,
      attributes: P
    });
    return /* @__PURE__ */ b.jsx(
      L,
      {
        ...y("root"),
        ref: R,
        __vars: {
          "--label-fz": Ce(f),
          "--label-lh": ue(f, "label-lh")
        },
        mod: [{ "label-position": h }, w],
        variant: p,
        size: f,
        ...x,
        children: /* @__PURE__ */ b.jsxs(
          L,
          {
            component: m,
            htmlFor: m === "label" ? d : void 0,
            ...y("body"),
            children: [
              r,
              /* @__PURE__ */ b.jsxs("div", { ...y("labelWrapper"), "data-disabled": i || void 0, children: [
                c && /* @__PURE__ */ b.jsx(
                  L,
                  {
                    component: v,
                    htmlFor: v === "label" ? d : void 0,
                    ...y("label"),
                    "data-disabled": i || void 0,
                    children: c
                  }
                ),
                a && /* @__PURE__ */ b.jsx(oe.Description, { size: f, __inheritStyles: !1, ...y("description"), children: a }),
                u && typeof u != "boolean" && /* @__PURE__ */ b.jsx(oe.Error, { size: f, __inheritStyles: !1, ...y("error"), children: u })
              ] })
            ]
          }
        )
      }
    );
  }
);
Xe.displayName = "@mantine/core/InlineInput";
var Ue = { root: "m_bf2d988c", inner: "m_26062bec", input: "m_26063560", icon: "m_bf295423", "input--outline": "m_215c4542" };
const Ye = no(null), To = Ye.Provider, Be = () => ro(Ye), [ko, Ro] = lo();
var Ge = { card: "m_26775b0a" };
const Ao = {
  withBorder: !0
}, jo = Z((e, { radius: t }) => ({
  card: {
    "--card-radius": he(t)
  }
})), ve = G((e, t) => {
  const o = M("CheckboxCard", Ao, e), {
    classNames: s,
    className: l,
    style: n,
    styles: r,
    unstyled: c,
    vars: a,
    checked: d,
    mod: i,
    withBorder: u,
    value: f,
    onClick: h,
    defaultChecked: m,
    onChange: v,
    attributes: p,
    ...g
  } = o, k = q({
    name: "CheckboxCard",
    classes: Ge,
    props: o,
    className: l,
    style: n,
    classNames: s,
    styles: r,
    unstyled: c,
    attributes: p,
    vars: a,
    varsResolver: jo,
    rootSelector: "card"
  }), w = Be(), P = typeof d == "boolean" ? d : w ? w.value.includes(f || "") : void 0, [x, R] = Te({
    value: P,
    defaultValue: m,
    finalValue: !1,
    onChange: v
  });
  return /* @__PURE__ */ b.jsx(ko, { value: { checked: x }, children: /* @__PURE__ */ b.jsx(
    oo,
    {
      ref: t,
      mod: [{ "with-border": u, checked: x }, i],
      ...k("card"),
      ...g,
      role: "checkbox",
      "aria-checked": x,
      onClick: (y) => {
        h?.(y), w?.onChange(f || ""), R(!x);
      }
    }
  ) });
});
ve.displayName = "@mantine/core/CheckboxCard";
ve.classes = Ge;
function _o({ children: e, role: t }) {
  const o = so();
  return o ? /* @__PURE__ */ b.jsx("div", { role: t, "aria-labelledby": o.labelId, "aria-describedby": o.describedBy, children: e }) : /* @__PURE__ */ b.jsx(b.Fragment, { children: e });
}
const xe = G((e, t) => {
  const {
    value: o,
    defaultValue: s,
    onChange: l,
    size: n,
    wrapperProps: r,
    children: c,
    readOnly: a,
    disabled: d,
    ...i
  } = M("CheckboxGroup", null, e), [u, f] = Te({
    value: o,
    defaultValue: s,
    finalValue: [],
    onChange: l
  }), h = (m) => {
    const v = typeof m == "string" ? m : m.currentTarget.value;
    !a && f(
      u.includes(v) ? u.filter((p) => p !== v) : [...u, v]
    );
  };
  return /* @__PURE__ */ b.jsx(To, { value: { value: u, onChange: h, size: n, disabled: d }, children: /* @__PURE__ */ b.jsx(
    oe.Wrapper,
    {
      size: n,
      ref: t,
      ...r,
      ...i,
      labelElement: "div",
      __staticSelector: "CheckboxGroup",
      children: /* @__PURE__ */ b.jsx(_o, { role: "group", children: c })
    }
  ) });
});
xe.classes = oe.Wrapper.classes;
xe.displayName = "@mantine/core/CheckboxGroup";
var qe = { indicator: "m_5e5256ee", icon: "m_1b1c543a", "indicator--outline": "m_76e20374" };
const zo = {
  icon: ke,
  variant: "filled"
}, Ho = Z(
  (e, { radius: t, color: o, size: s, iconColor: l, variant: n, autoContrast: r }) => {
    const c = de({ color: o || e.primaryColor, theme: e }), a = c.isThemeColor && c.shade === void 0 ? `var(--mantine-color-${c.color}-outline)` : c.color;
    return {
      indicator: {
        "--checkbox-size": ue(s, "checkbox-size"),
        "--checkbox-radius": t === void 0 ? void 0 : he(t),
        "--checkbox-color": n === "outline" ? a : Q(o, e),
        "--checkbox-icon-color": l ? Q(l, e) : Ae(r, e) ? be({ color: o, theme: e, autoContrast: r }) : void 0
      }
    };
  }
), Se = G((e, t) => {
  const o = M("CheckboxIndicator", zo, e), {
    classNames: s,
    className: l,
    style: n,
    styles: r,
    unstyled: c,
    vars: a,
    icon: d,
    indeterminate: i,
    radius: u,
    color: f,
    iconColor: h,
    autoContrast: m,
    checked: v,
    mod: p,
    variant: g,
    disabled: k,
    attributes: w,
    ...P
  } = o, x = q({
    name: "CheckboxIndicator",
    classes: qe,
    props: o,
    className: l,
    style: n,
    classNames: s,
    styles: r,
    unstyled: c,
    attributes: w,
    vars: a,
    varsResolver: Ho,
    rootSelector: "indicator"
  }), R = Ro(), y = typeof v == "boolean" || typeof i == "boolean" ? v || i : R?.checked || !1;
  return /* @__PURE__ */ b.jsx(
    L,
    {
      ref: t,
      ...x("indicator", { variant: g }),
      variant: g,
      mod: [{ checked: y, disabled: k }, p],
      ...P,
      children: /* @__PURE__ */ b.jsx(d, { indeterminate: i, ...x("icon") })
    }
  );
});
Se.displayName = "@mantine/core/CheckboxIndicator";
Se.classes = qe;
const Do = {
  labelPosition: "right",
  icon: ke,
  variant: "filled"
}, Eo = Z(
  (e, { radius: t, color: o, size: s, iconColor: l, variant: n, autoContrast: r }) => {
    const c = de({ color: o || e.primaryColor, theme: e }), a = c.isThemeColor && c.shade === void 0 ? `var(--mantine-color-${c.color}-outline)` : c.color;
    return {
      root: {
        "--checkbox-size": ue(s, "checkbox-size"),
        "--checkbox-radius": t === void 0 ? void 0 : he(t),
        "--checkbox-color": n === "outline" ? a : Q(o, e),
        "--checkbox-icon-color": l ? Q(l, e) : Ae(r, e) ? be({ color: o, theme: e, autoContrast: r }) : void 0
      }
    };
  }
), ee = G((e, t) => {
  const o = M("Checkbox", Do, e), {
    classNames: s,
    className: l,
    style: n,
    styles: r,
    unstyled: c,
    vars: a,
    color: d,
    label: i,
    id: u,
    size: f,
    radius: h,
    wrapperProps: m,
    checked: v,
    labelPosition: p,
    description: g,
    error: k,
    disabled: w,
    variant: P,
    indeterminate: x,
    icon: R,
    rootRef: y,
    iconColor: S,
    onChange: T,
    autoContrast: W,
    mod: N,
    attributes: I,
    ..._
  } = o, H = Be(), V = f || H?.size, D = q({
    name: "Checkbox",
    props: o,
    classes: Ue,
    className: l,
    style: n,
    classNames: s,
    styles: r,
    unstyled: c,
    attributes: I,
    vars: a,
    varsResolver: Eo
  }), { styleProps: O, rest: $ } = to(_), Y = co(u), J = {
    checked: H?.value.includes($.value) ?? v,
    onChange: (ge) => {
      H?.onChange(ge), T?.(ge);
    },
    disabled: H?.disabled ?? w
  }, ce = z(null), F = t || ce;
  return j(() => {
    F && "current" in F && F.current && (F.current.indeterminate = x || !1, x ? F.current.setAttribute("data-indeterminate", "true") : F.current.removeAttribute("data-indeterminate"));
  }, [x, F]), /* @__PURE__ */ b.jsx(
    Xe,
    {
      ...D("root"),
      __staticSelector: "Checkbox",
      __stylesApiProps: o,
      id: Y,
      size: V,
      labelPosition: p,
      label: i,
      description: g,
      error: k,
      disabled: J.disabled,
      classNames: s,
      styles: r,
      unstyled: c,
      "data-checked": J.checked || v || void 0,
      variant: P,
      ref: y,
      mod: N,
      inert: $.inert,
      ...O,
      ...m,
      children: /* @__PURE__ */ b.jsxs(L, { ...D("inner"), mod: { "data-label-position": p }, children: [
        /* @__PURE__ */ b.jsx(
          L,
          {
            component: "input",
            id: Y,
            ref: F,
            mod: { error: !!k },
            ...D("input", { focusable: !0, variant: P }),
            ...$,
            ...J,
            inert: $.inert,
            type: "checkbox"
          }
        ),
        /* @__PURE__ */ b.jsx(R, { indeterminate: x, ...D("icon") })
      ] })
    }
  );
});
ee.classes = { ...Ue, ...Po };
ee.displayName = "@mantine/core/Checkbox";
ee.Group = xe;
ee.Indicator = Se;
ee.Card = ve;
export {
  ee as C,
  _o as I,
  se as S,
  Me as T,
  Ae as a,
  be as b,
  Xe as c,
  Po as d,
  $o as g
};
